<div class="flex shrink-0 justify-center py-2">
    <p-button
        [loading]="isLoading"
        (click)="reload()"
        label="{{ 'common.load' | translate }}"
    ></p-button>
</div>

<div class="min-h-0 flex-1 overflow-x-hidden overflow-y-auto">
<p-timeline [value]="items" align="right">
    <ng-template pTemplate="marker" let-st>
        <span [pTooltip]="getCreatorName(st)" class="custom-marker">
            <i
                *ngIf="st.targetStoragePlaceId && st.originStoragePlaceId; else restock"
                class="fa fa-arrows-turn-to-dots"
            ></i>
            <ng-template #restock>
                <i
                    *ngIf="st.targetStoragePlaceId"
                    class="fa fa-arrow-trend-up positive-stock-transaction"
                ></i>
                <i
                    *ngIf="st.originStoragePlaceId"
                    class="fa fa-arrow-trend-down negative-stock-transaction"
                ></i>
            </ng-template>
        </span>
    </ng-template>
    <ng-template pTemplate="content" let-st>
        <!-- Restock -->
        <!-- {{st | json}} -->
        <div *ngIf="st.originStoragePlaceId && st.targetStoragePlaceId; else inOrOut">
            <span class="stock-transaction-quantity">
                {{ st.quantity }}
            </span>
            <br />
            <span [pTooltip]="st.originStoragePlace.description">{{
                st.originStoragePlace.identifier
            }}</span>
            <i class="fa fa-arrow-right m-1"></i>
            <span [pTooltip]="st.targetStoragePlace.description"
                >{{ st.targetStoragePlace.identifier }}
            </span>
        </div>
        <ng-template #inOrOut>
            <div *ngIf="st.originStoragePlaceId">
                <span class="negative-stock-transaction stock-transaction-quantity">{{
                    st.quantity
                }}</span>
                <br />
                <span>{{ st.originStoragePlace?.identifier }}</span>
                <span *ngIf="st.targetStoragePlace?.description">
                    - {{ st.targetStoragePlace?.description }}</span
                >
            </div>
            <div *ngIf="st.targetStoragePlaceId">
                <span class="positive-stock-transaction stock-transaction-quantity">{{
                    st.quantity
                }}</span>
                <br />
                <span>{{ st.targetStoragePlace?.identifier }}</span>
                <span *ngIf="st.targetStoragePlace?.description">
                    - {{ st.targetStoragePlace?.description }}</span
                >
            </div>
        </ng-template>
    </ng-template>
    <ng-template pTemplate="opposite" let-st>
        <small class="text-muted-color">{{ st.dateOfTransaction | date: 'medium' }}</small>
        <br />
        @if (st.getDocumentLineItem || st.getDocument) {
            <i class="fa fa-file-lines m-1"></i>
            <a class="text-muted-color" [routerLink]="getDocumentLink(st)">
                {{
                    st.getDocumentLineItem?.document?.identifier ||
                        st.getDocument?.identifier ||
                        st.metaData?.undoInformation?.documentIdentifier
                }}
            </a>
            @if (!st.getDocumentLineItem || st.metaData?.undoInformation) {
                <i
                    class="fa fa-trash-can m-1 text-yellow-500"
                    [pTooltip]="undoInformationTemplate"
                ></i>
            }
        } @else if (st.metaData?.undoInformation?.documentIdentifier) {
            <i class="fa fa-file-lines m-1"></i>
            <i class="text-muted-color" [pTooltip]="undoInformationTemplate">
                {{ 'warehouse.document-deleted' | translate }}
            </i>
        }
        <!-- TODO Members -->
        @else {
            <small class="text-muted-color">{{
                'warehouse.manual-stock-transaction' | translate
            }}</small>
        }
        <ng-template #undoInformationTemplate>
            <div class="flex flex-col">
                @if (!st.getDocumentLineItem && st.getDocument) {
                    <span class="mb-2">{{
                        'warehouse.document-line-item-deleted' | translate
                    }}</span>
                }
                <div class="flex justify-between gap-3">
                    <span class="text-muted-color">{{ 'columns.positionNumber' | translate }}</span>
                    <span>{{ st.metaData?.undoInformation?.documentLineItemPositionNumber }}</span>
                </div>
                <div class="flex justify-between gap-3">
                    <span class="text-muted-color">{{ 'columns.positionText' | translate }}</span>
                    <span>{{ st.metaData?.undoInformation?.documentLineItemPositionText }}</span>
                </div>
                <div class="flex justify-between gap-3">
                    <span class="text-muted-color">{{ 'columns.product._' | translate }}</span>
                    <span>{{
                        st.metaData?.undoInformation?.documentLineItemProductIdentifier
                    }}</span>
                </div>
                <div class="flex justify-between gap-3">
                    <span class="text-muted-color">{{ 'document.identifier' | translate }}</span>
                    <span>{{ st.metaData?.undoInformation?.documentIdentifier }}</span>
                </div>
                <div class="flex justify-between gap-3">
                    <span class="text-muted-color">{{
                        'columns.documentDefinition._' | translate
                    }}</span>
                    <span>{{ st.metaData?.undoInformation?.documentDefinitionIdentifier }}</span>
                </div>
                <i class="text-muted-color text-sm mt-2">
                    {{
                        'common.deleted-at-by'
                            | translate
                                : {
                                      date: st.metaData?.undoInformation?.undoDate | date: 'short',
                                      user: getCreatorName(st)
                                  }
                    }}
                </i>
            </div>
        </ng-template>
    </ng-template>
</p-timeline>

<div *ngIf="initialLoadDone" class="py-2 text-center">
    <p-button
        [loading]="isLoading"
        *ngIf="items.length < totalCount; else endListTemplate"
        (click)="loadMore()"
        label="{{ 'common.load-more' | translate }}"
    ></p-button>
    <ng-template #endListTemplate>{{ 'common.end-of-list' | translate }}</ng-template>
</div>
</div>
